var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.566406,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.566406,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.4414C6.035 14.4414 3.625 12.0314 3.625 9.06641C3.625 6.10141 6.035 3.69141 9 3.69141C11.965 3.69141 14.375 6.10141 14.375 9.06641C14.375 12.0314 11.965 14.4414 9 14.4414ZM9 4.44141C6.45 4.44141 4.375 6.51641 4.375 9.06641C4.375 11.6164 6.45 13.6914 9 13.6914C11.55 13.6914 13.625 11.6164 13.625 9.06641C13.625 6.51641 11.55 4.44141 9 4.44141Z",
    fill: "#027186"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50012 13.9414H7.00012C6.79512 13.9414 6.62512 13.7714 6.62512 13.5664C6.62512 13.3614 6.78512 13.1964 6.99012 13.1914C6.20512 10.5114 6.20512 7.62141 6.99012 4.94141C6.78512 4.93641 6.62512 4.77141 6.62512 4.56641C6.62512 4.36141 6.79512 4.19141 7.00012 4.19141H7.50012C7.62012 4.19141 7.73512 4.25141 7.80512 4.34641C7.87512 4.44641 7.89512 4.57141 7.85512 4.68641C6.91512 7.51141 6.91512 10.6214 7.85512 13.4514C7.89512 13.5664 7.87512 13.6914 7.80512 13.7914C7.73512 13.8814 7.62012 13.9414 7.50012 13.9414Z",
    fill: "#027186"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 13.9414C10.4602 13.9414 10.4202 13.9364 10.3802 13.9214C10.1852 13.8564 10.0752 13.6414 10.1452 13.4464C11.0852 10.6214 11.0852 7.51137 10.1452 4.68137C10.0802 4.48637 10.1852 4.27137 10.3802 4.20637C10.5802 4.14137 10.7902 4.24637 10.8552 4.44137C11.8502 7.42137 11.8502 10.7014 10.8552 13.6764C10.8052 13.8414 10.6552 13.9414 10.5002 13.9414Z",
    fill: "#027186"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.6664C7.605 11.6664 6.215 11.4714 4.875 11.0764C4.87 11.2764 4.705 11.4414 4.5 11.4414C4.295 11.4414 4.125 11.2714 4.125 11.0664V10.5664C4.125 10.4464 4.185 10.3314 4.28 10.2614C4.38 10.1914 4.505 10.1714 4.62 10.2114C7.445 11.1514 10.56 11.1514 13.385 10.2114C13.5 10.1714 13.625 10.1914 13.725 10.2614C13.825 10.3314 13.88 10.4464 13.88 10.5664V11.0664C13.88 11.2714 13.71 11.4414 13.505 11.4414C13.3 11.4414 13.135 11.2814 13.13 11.0764C11.785 11.4714 10.395 11.6664 9 11.6664Z",
    fill: "#027186"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4999 7.94146C13.4599 7.94146 13.4199 7.93646 13.3799 7.92146C10.5549 6.98146 7.43989 6.98146 4.61489 7.92146C4.41489 7.98646 4.20489 7.88146 4.13989 7.68646C4.07989 7.48646 4.18489 7.27646 4.37989 7.21146C7.35989 6.21646 10.6399 6.21646 13.6149 7.21146C13.8099 7.27646 13.9199 7.49146 13.8499 7.68646C13.8049 7.84146 13.6549 7.94146 13.4999 7.94146Z",
    fill: "#027186"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.eb7836142f3afd908c971773b78d4c02.svg";
export { ForwardRef as ReactComponent };